<template>
  <div class="box box-5" :class="{ 'ani-scale': !isMobileSize }" @click="$emit('openVideo', 5)">
    <img class="img-5" :src="img5" alt="" />
    <img class="add-icon" :src="addIcon" alt="" />
    <div class="title">{{ $t('keypalTwo.introduce.desc_3') }}</div>
    <div class="desc">{{ $t('keypalTwo.introduce.desc_8') }}</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters(['isMobileSize']),
    img5() {
      return require('../../assets/images/keypal-two/introduce-5.png');
    },
    addIcon() {
      return require('../../assets/images/keypal-two/add-1.png');
    },
  },
};
</script>

<style lang="scss" scoped>
@import url('./card.scss');
.box-5 {
  width: 384px;
  height: 213px;

  .img-5 {
    width: 105px;
    height: 105px;
    position: absolute;
    top: 20px;
    right: 24px;
  }
}

@media screen and (max-width: 1200px) {
  .box-5 {
    width: calc(384 / 1300 * 100vw);
    height: calc(213 / 1300 * 100vw);
    .img-5 {
      width: calc(105 / 1300 * 100vw);
      height: calc(105 / 1300 * 100vw);
    }
  }
}

@media screen and (max-width: 767px) {
  .box-5 {
    width: 276px;
    height: auto;
    .img-5 {
      width: 115px;
      height: 115px;
      position: absolute;
      left: 50%;
      top: 165px;
      transform: translateX(-50%);
    }
  }
}
</style>
